export default "__VITE_ASSET__GT2zsD5T__"